<template>
  <v-row justify="center">
    <v-dialog v-model="show" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="#b3a258">
          <v-btn icon dark @click="onClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title style="font-size: 1.2em;">{{header}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      
        <v-divider></v-divider>
        <v-card-text>
          <ul class="text-left mt-10" :style="fontSize">
            <li class="list-item" v-for="(data, index) in datas.detail" :key="index" :class="data.class" style="font-weight: bold;">
              {{data.ask.name}}
              <ul>
                <li v-html="data.ans.name" style="font-weight: normal;"></li>
              </ul>
            </li>
          </ul>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
const axios = require("axios").default;

export default {
  name: "FAQ",
  props: {
    show: Boolean
  },
  data() {
    return {
      datas: [],
      header: '',
      lang: this.$route.params.lang,
      fontSize: {}
    };
  },
  methods: {
    getData() {
      let self = this;
      if(this.lang == 'th') { this.fontSize = { "font-size": "18px", "font-family": "\"Browallia New\", sans-serif" }; }
      axios
        .get("/data/faq/"+this.lang+".json")
        // eslint-disable-next-line no-unused-vars
        .then(res => {
          self.datas = res.data;
          self.header = res.data.header.name;
        });
      // .cathc();
    },
    onClose() {
      this.$emit('onClose');
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style scoped>
.tc-one {
  padding-left: 25px;
  text-indent: -1.2em;
  list-style-type: none;
  }
  .tc-two {
    padding-left: 25px;
    text-indent: -1.7em;
    list-style-type: none;
  }
  .list-item {
    font-size: 1.2em;
    margin-top: 15px;
  }
  ul, li {
    list-style-type: none;
  }
  .avc-color {
    color: #b3a258;
  }
</style>